import { PlannerItemContextProvider } from '@context/PlannerItemContext';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import {
  forwardRef,
  useMemo,
  useState,
  useRef,
  useCallback,
  memo
} from 'react';
import { Spacings } from '@styles/index';
import Day from '@cont/PlannerV2/Day';
import PlannerItemMenuWrapper from './PlannerItemMenu/PlannerItemMenuWrapper';

const StyledListNew = styled.div`
  width: max(calc(100% + ((100vw - 1136px) / 2) - 4px), 100%);
  scrollbar-width: ${Spacings.SPACING_2B};
  ::-webkit-scrollbar {
    width: ${Spacings.SPACING_2B};
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    width: ${Spacings.SPACING_2B};
    height: 85px;
    border-radius: ${Spacings.SPACING_10B};
    background: var(--color-text-secondary);
  }
`;

const PlannerItemList = forwardRef(
  ({
    plannerItemsByDaysV2,
    refreshFeatureCards,
    showBrowse,
    todayKey,
    selectedDateKey,
    featureCards = []
  }) => {
    const {
      query: { goalUID }
    } = useRouter();

    const itemData = useMemo(() => {
      return {
        plannerItemsByDaysV2,
        todayKey,
        showBrowse,
        featureCards
      };
    }, [plannerItemsByDaysV2, showBrowse, todayKey, featureCards]);

    const [menuAnchorEl, setItemAnchorEl] = useState(null);
    const selectedItemRef = useRef(null);
    const closeActionMenu = useCallback(() => {
      setItemAnchorEl(null);
      selectedItemRef.current = null;
    }, []);
    const showActionMenu = useCallback((elem, item) => {
      selectedItemRef.current = item;
      setItemAnchorEl(elem);
    }, []);

    return (
      <PlannerItemContextProvider
        goalUID={goalUID}
        refreshFeatureCards={refreshFeatureCards}
        showActionMenu={showActionMenu}
        closeActionMenu={closeActionMenu}
        menuAnchorEl={menuAnchorEl}
        selectedItemRef={selectedItemRef}
      >
        <StyledListNew>
          <Day selectedDateKey={selectedDateKey || todayKey} data={itemData} />
        </StyledListNew>
        <PlannerItemMenuWrapper />
      </PlannerItemContextProvider>
    );
  }
);

PlannerItemList.displayName = 'PlannerItemList';

PlannerItemList.propTypes = {
  plannerItemsByDaysV2: PropTypes.shape([]).isRequired,
  showBrowse: PropTypes.bool,
  featureCards: PropTypes.arrayOf(PropTypes.shape({})),
  todayKey: PropTypes.string.isRequired,
  selectedDateKey: PropTypes.string.isRequired,
  refreshFeatureCards: PropTypes.func.isRequired
};

PlannerItemList.defaultProps = {
  showBrowse: false,
  featureCards: []
};

const MemoizedPlannerItemList = memo(PlannerItemList);
MemoizedPlannerItemList.displayName = 'MemoizedPlannerItemList';
export default MemoizedPlannerItemList;
